import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { displayUserName } from '../../../../services/utilityFunctions';
import sessionProp from '../../propTypes/sessionProp';

function ListTrainer({ t, user }) {
  const { softSkills = {} } = user || {};
  const { languages = [] } = softSkills || {};
  const avatar = user && user.image ? user.image.thumb : '/images/no_user.png';
  return (
    <div className="row">
      <div className="img-trainer col-lg-2 col-md-2 col-sm-3">
       <span className="session-subheader-item">
          <span className="session-subheader-item-image">
            <img
              className="session-hostTrainer-image"
              src={avatar}
              alt="Host"
            />
          </span>
       </span>
      </div>
      <div style={{ alignSelf: 'center' }} className="name-trainer col-sm-5 col-lg-10 col-md-9">
        <div className="session-details">
          <div className="session-header">
            <span
              className="session-header-name"
            >
              {displayUserName(user)}
            </span>
          </div>
          <div className="session-subheader col-lg-7">
            <span className="session-subheader-item">
              { user &&
              <span className="session-subheader-item-value">
                {user.title || ''}
              </span>
              }
            </span>
            {languages?.length > 0 && (
              <>
                <span className="session-subheader-item">
                  <span className="session-subheader-item-title">
                    {t('sessions_language')}
                  </span>
                  {
                    languages && languages.map(item => (
                      <span className="session-subheader-item-value">
                        <img className="rounded-circle language-icon" src={item.flag.thumb} alt={item.name} />
                      </span>
                    ))
                  }
                </span>
              </>
            )}
          {/*  <div style={{ alignSelf: 'center;' }}>
              <div className="session-actions row">
                <Anchor
                  href="#"
                  className="btn m-btn--pill btn-dynamic navigation-button col-12"
                >
                  {t('sessionDetails_seeProfile')}
                </Anchor>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

ListTrainer.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape(sessionProp.propType).isRequired,
};

export default translate(ListTrainer);
